import { useEffect, useState } from "react";
import "./PopupForm.css";

export default function PopupForm() {
  const [show, setShow] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [purity, setPurity] = useState("");
  const [gram, setGram] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !phone) {
      alert("Please fill required fields");
      return;
    }

    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", phone);
    formData.append("purity", purity);
    formData.append("gram", gram);

    try {
      const res = await fetch("https://sellgoldcompany.in/send.php", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (data.status === "success") {
        alert("Message sent ✅");
        setName("");
        setEmail("");
        setPhone("");
        setPurity("");
        setGram("");
        setShow(false);
      } else {
        alert("Error ❌");
      }
    } catch {
      alert("Server error ❌");
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box">

        <button className="close-btn" onClick={() => setShow(false)}>
          ✕
        </button>

        <h2>Get in Touch with Trusted Gold Buyers</h2>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="tel"
            placeholder="Phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            required
          />

          <select
            value={purity}
            onChange={(e) => setPurity(e.target.value)}
          >
            <option value="">Gold Purity</option>
            <option>18K</option>
            <option>20K</option>
            <option>22K</option>
            <option>24K</option>
          </select>

          <input
            type="number"
            placeholder="Gram"
            value={gram}
            onChange={(e) => setGram(e.target.value)}
          />

          <button type="submit" className="submit-btn">
            SUBMIT
          </button>
        </form>

      </div>
    </div>
  );
}